<template>
  <footer class="bg-gray-700 text-white py-4">
    <div class="text-sm text-gray-500 flex justify-center gap-4 mt-4">
      <router-link to="/privacy" class="hover:text-blue-600 hover:underline transition-colors">隱私權政策</router-link>
      <span>|</span>
      <router-link to="/terms" class="hover:text-blue-600 hover:underline transition-colors">服務條款</router-link>
      <span>|</span>
      <router-link to="/report" class="hover:text-blue-600 hover:underline transition-colors">回報問題</router-link>
      <span>|</span>
      <router-link to="/about" class="hover:text-blue-600 hover:underline transition-colors">關於我</router-link>

    </div>

    <p class="text-xs text-gray-400 mt-2 text-center">© 2025 工具豬豬. All rights reserved.</p>
  </footer>
</template>
